import type { TaxCategoryKeyType } from './tax-categories.js';

// AD-10 (amended 2026-09-23): the wizard asks "What was this for?" before the category, and each
// answer offers only its categories. Used by the wizard only; the server derives capital
// treatment from the category itself. Pinned against the seed by apps/api/src/categoryGroups.test.ts.
export type SpendingPurpose = 'improvement' | 'repair_or_upkeep' | 'not_building_work';

export const CATEGORY_PURPOSE: Record<TaxCategoryKeyType, SpendingPurpose | 'not_offered'> = {
  capital_improvement: 'improvement',
  repairs: 'repair_or_upkeep',
  cleaning_and_supplies: 'repair_or_upkeep',
  supplies: 'repair_or_upkeep',
  advertising: 'not_building_work',
  auto_and_travel: 'not_building_work',
  commissions: 'not_building_work',
  insurance: 'not_building_work',
  legal_and_professional: 'not_building_work',
  management_fees: 'not_building_work',
  mortgage_interest: 'not_building_work',
  other_interest: 'not_building_work',
  taxes_and_licenses: 'not_building_work',
  utilities: 'not_building_work',
  other_expenses: 'not_building_work',
  // Not money paid to anyone; it is computed from basis. The server still accepts the key.
  depreciation: 'not_offered',
};
